import { h, Component } from 'preact'
import Brand from './../brand/Brand'
import style from './style'

export default class Splash extends Component {
  render() {
    return (
      <article class={style.splash}>
        <section class={style.brand}>
          <Brand />
        </section>
        <section>
          <h1>fiday</h1>
        </section>
      </article>
    )
  }
}



// WEBPACK FOOTER //
// ./components/splash/Splash.js